import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-content-creation-dialog-actions",
  templateUrl: "./content-creation-dialog-actions.component.html",
  styleUrls: ["./content-creation-dialog-actions.component.scss"],
})
export class ContentCreationDialogActionsComponent {
  @Input() public isSaveDisabled = true;
  @Input() public isSaving = true;
  @Input() public creationMode = true;
  @Output() public cancel = new EventEmitter<void>();
  @Output() public preview = new EventEmitter<void>();
  @Output() public save = new EventEmitter<void>();

  public onActionPreview(): void {
    this.preview.emit();
  }

  public onActionSave(): void {
    this.save.emit();
  }

  public onActionCancel(): void {
    this.cancel.emit();
  }
}
